import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../lib/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(private storage: LocalStorageService, public router: Router) {

  }

  canActivate(): boolean {
    if (!this.storage.isAuthenticated()) {
      this.router.navigate(['auth/login']);
      return false;
    }

    return true;
  }

}